import { readableColor } from "polished"

export function getColorFromVariant(variant) {
  switch (variant) {
    case "primary":
      return (props) => props.theme.colors.primary
    case "secondary":
      return (props) => props.theme.colors.secondaryAlternative || props.theme.colors.secondary
    case "home":
      return (props) => props.theme.colors.home.headings
    case "content":
      return (props) => props.theme.colors.content.text
    case "contentv2":
      return (props) => props.theme.colors.fields.contentText
    case "contentv2Heading":
      return (props) => props.theme.colors.primary
    case "contentv2PlainHeading":
      return (props) => props.theme.colors.fields.contentHeading
    case "simpleForm":
      return (props) => props.theme.colors.fields.fieldsetText
    case "body":
      return (props) => props.theme.colors.body
    case "neutral":
      return (props) => props.theme.colors.fields.label
    case "secondaryReadable":
      return (props) =>
        readableColor(
          props.theme.colors.secondary,
          props.theme.colors.buttons.darkColor,
          props.theme.colors.buttons.lightColor,
          false
        )
    default:
      return (props) => props.theme.colors.body
  }
}
